import { render, staticRenderFns } from "./MacrosCategories.vue?vue&type=template&id=1d336f32"
import script from "./MacrosCategories.vue?vue&type=script&lang=js"
export * from "./MacrosCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports